import { createClient } from '@supabase/supabase-js';

// NOTE: Dans un environnement réel, ces variables doivent être dans un fichier .env
// Pour cette démo, l'utilisateur devra les saisir ou les remplacer ici.
const SUPABASE_URL = process.env.REACT_APP_SUPABASE_URL || 'https://gsqqyewbnskgaqhaxfdc.supabase.co';
const SUPABASE_ANON_KEY = process.env.REACT_APP_SUPABASE_ANON_KEY || 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6ImdzcXF5ZXdibnNrZ2FxaGF4ZmRjIiwicm9sZSI6ImFub24iLCJpYXQiOjE3NjQ3NzkxMTQsImV4cCI6MjA4MDM1NTExNH0.0HvkeL8586rJTuNDhLr7GMm_GBgtFb4gAjLxbdFeR9c';

export const supabase = createClient(SUPABASE_URL, SUPABASE_ANON_KEY);

// Helper pour vérifier si Supabase est configuré
export const isSupabaseConfigured = () => {
  return SUPABASE_URL !== 'https://votre-projet.supabase.co';
};